import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { PsHttpService } from '@patsnap/tahiti-core';
import type { PatSnapSuccessResponseData } from '@patsnap/tahiti-core';
import type { AddTrialApi, AddFreePkgParams } from '../add-free-api';
import type { ProductOnboardingCheckResponse } from '../../types';
import { eurekaApiUrlPrefix } from '@telecom/shared/domain-config';

@injectable()
export class AddTrialApiImpl extends PsHttpService implements AddTrialApi {
    get options() {
        return {
            baseURL: '/api',
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    async checkProductOnboarding(empowerType: string, extendBody: Record<string, any>): Promise<ProductOnboardingCheckResponse> {
        const result = await this.post<PatSnapSuccessResponseData<ProductOnboardingCheckResponse>>({
            url: '/account-privilege/product-onboarding/check',
            baseURL: eurekaApiUrlPrefix,
            data: extendBody,
        });
        return result.data;
    }

    async addFreePkg(params: AddFreePkgParams): Promise<void> {
        await this.post({
            url: '/account-privilege/add-trial',
            baseURL: eurekaApiUrlPrefix,
            params: {
                from: params.from,
            },
            data: params.extendBody,
        });
    }
}
